module.exports = __webpack_public_path__ + "img/tl.89a936d4.png";